import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AspectRatio from 'react-aspect-ratio';
import DLUnloader from 'appSrc/components/Shards/Unloader';
import uuidv4 from 'uuid/v4';
import { Mixpanel } from 'appSrc/components/Analytics/Mixpanel';
import { GoogleTagManager } from 'appSrc/components/Analytics/GoogleTagManager';
import { updateVars } from 'appSrc/redux/actions';
import style from './styles/style.module.css';


class YoutubePlayer extends Component {
    constructor( props ) {
        super( props );

        this.id = `ytplayer-${ uuidv4() }`;
        this.player = {};
        this.isUnMuted = false;
        this.doNotTrack = false;
        this.videoTitle = '';
        this.startTime = 0;
        this.hasPaused = false;
        this.isPaused = true;
        this.autoplay = this.props.autoplay;
    }
    componentDidMount() {
        //wait for YT variable to be active
        var intervalID = window.setInterval( () => {
            if( window.YT && window.YT.Player ) {
                window.clearInterval( intervalID );
                this.activatePlayer();
                this.props.dispatch( updateVars( { videoPlaying: this.id } ) );
            }
        }, 250 );

        DLUnloader.register( this.id, () => {
            if( !this.isPaused ) {
                this.hasPaused = true;
                this.isPaused = true;
                try {
                    var pauseTime = this.player.getCurrentTime();

                    GoogleTagManager.track( 'Video Paused', {
                        video_provider: 'youtube',
                        video_provider_id: this.props.videoId,
                        video_title: this.videoTitle,
                        attached_to: this.props.attachmentType,
                        attached_id: this.props.attachmentId,
                        video_author_id: this.props.authorId,
                        start_time: this.startTime,
                        pause_time: pauseTime,
                        ...this.props.metaData,
                    } );
                    Mixpanel.track( 'videoPaused', {
                        video_provider: 'youtube',
                        video_provider_id: this.props.videoId,
                        video_title: this.videoTitle,
                        attached_to: this.props.attachmentType,
                        attached_id: this.props.attachmentId,
                        video_author_id: this.props.authorId,
                        start_time: this.startTime,
                        pause_time: pauseTime,
                        ...this.props.metaData,
                    } );
                    this.startTime = pauseTime;
                } catch (e) {
                    console.error( 'Analytics error', e );
                }
            }
        } );
    }
    componentWillUnmount() {
        DLUnloader.unregister( this.id );
        if( !this.isPaused ) {
            this.hasPaused = true;
            this.isPaused = true;
            try {
                var pauseTime = this.player.getCurrentTime();

                GoogleTagManager.track( 'Video Paused', {
                    video_provider: 'youtube',
                    video_provider_id: this.props.videoId,
                    video_title: this.videoTitle,
                    attached_to: this.props.attachmentType,
                    attached_id: this.props.attachmentId,
                    video_author_id: this.props.authorId,
                    start_time: this.startTime,
                    pause_time: pauseTime,
                    ...this.props.metaData,
                } );
                Mixpanel.track( 'videoPaused', {
                    video_provider: 'youtube',
                    video_provider_id: this.props.videoId,
                    video_title: this.videoTitle,
                    attached_to: this.props.attachmentType,
                    attached_id: this.props.attachmentId,
                    video_author_id: this.props.authorId,
                    start_time: this.startTime,
                    pause_time: pauseTime,
                    ...this.props.metaData,
                } );
                this.startTime = pauseTime;
            } catch (e) {
                console.error( 'Analytics error', e );
            }
        }
    }
    componentDidUpdate() {
        if( this.props.videoPlaying !== this.id ) {
            this.player && this.player.pauseVideo && this.player.pauseVideo();
        }
    }
    activatePlayer = () => {
        this.player = new window.YT.Player( this.id, {
            videoId: this.props.videoId,
            playerVars: {
                autoplay: this.autoplay ? 1 : 0,
                modestbranding: 1,
                rel: 0,
                cc_lang_pref: 'en',
                cc_load_policy: 1,
                enablejsapi: 1,
                origin: process.env.origin,
            },
            events: {
                'onReady': ( event ) => {
                    this.videoTitle = event.target.getVideoData().title;
                    if( this.props.mute ) {
                        event.target.mute();
                    }
                    event.target.playVideo();
                    this.props.onActivate();
                },
                onStateChange: ( event ) => {
                    if( this.player.isMuted() && this.player.getPlayerState() == 2 && !this.isUnMuted ) {
                        this.player.unMute();
                        this.player.playVideo();
                        this.isUnMuted = true;
                        this.doNotTrack = true;
                    }
                    else if( !this.doNotTrack ) {
                        this.trackVideoChange( event );
                    } else if( this.doNotTrack ) {
                        this.doNotTrack = false;
                    }
                },
            },
        } );
    }
    trackVideoChange = ( event ) => {
        if( event.data == window.YT.PlayerState.ENDED ) {
            this.isPaused = true;
            try {
                GoogleTagManager.track( 'Video Finished', {
                    video_provider: 'youtube',
                    video_provider_id: this.props.videoId,
                    video_title: this.videoTitle,
                    attached_to: this.props.attachmentType,
                    attached_id: this.props.attachmentId,
                    video_author_id: this.props.authorId,
                    start_time: this.startTime,
                    end_time: this.player.getCurrentTime(),
                    ...this.props.metaData,
                } );
                Mixpanel.track( 'videoFinished', {
                    video_provider: 'youtube',
                    video_provider_id: this.props.videoId,
                    video_title: this.videoTitle,
                    attached_to: this.props.attachmentType,
                    attached_id: this.props.attachmentId,
                    video_author_id: this.props.authorId,
                    start_time: this.startTime,
                    end_time: this.player.getCurrentTime(),
                    ...this.props.metaData,
                } );
            } catch (e) {
                console.error( 'Analytics error', e );
            }
        } else if( event.data == window.YT.PlayerState.PLAYING ) {
            this.isPaused = false;
            try {
                this.startTime = this.player.getCurrentTime();
                let gEventName, mixEventName;
                if( !this.hasPaused ) {
                    if( this.autoplay ) {
                        gEventName = 'Video Autoplay';
                        mixEventName = 'videoAutoplay';
                    } else {
                        gEventName = 'Video Started';
                        mixEventName = 'videoStarted';
                    }
                } else {
                    gEventName = 'Video Resumed';
                    mixEventName = 'videoResumed';
                }
                GoogleTagManager.track( gEventName, {
                    video_provider: 'youtube',
                    video_provider_id: this.props.videoId,
                    video_title: this.videoTitle,
                    attached_to: this.props.attachmentType,
                    attached_id: this.props.attachmentId,
                    video_author_id: this.props.authorId,
                    start_time: this.startTime,
                    resuming: this.hasPaused,
                    ...this.props.metaData,
                } );
                Mixpanel.track( mixEventName, {
                    video_provider: 'youtube',
                    video_provider_id: this.props.videoId,
                    video_title: this.videoTitle,
                    attached_to: this.props.attachmentType,
                    attached_id: this.props.attachmentId,
                    video_author_id: this.props.authorId,
                    start_time: this.startTime,
                    resuming: this.hasPaused,
                    ...this.props.metaData,
                } );
            } catch (e) {
                console.error( 'Analytics error', e );
            }
        } else if( event.data == window.YT.PlayerState.PAUSED ) {
            this.hasPaused = true;
            this.isPaused = true;
            try {
                var pauseTime = this.player.getCurrentTime();
                GoogleTagManager.track( 'Video Paused', {
                    video_provider: 'youtube',
                    video_provider_id: this.props.videoId,
                    video_title: this.videoTitle,
                    attached_to: this.props.attachmentType,
                    attached_id: this.props.attachmentId,
                    video_author_id: this.props.authorId,
                    start_time: this.startTime,
                    pause_time: pauseTime,
                    ...this.props.metaData,
                } );
                Mixpanel.track( 'videoPaused', {
                    video_provider: 'youtube',
                    video_provider_id: this.props.videoId,
                    video_title: this.videoTitle,
                    attached_to: this.props.attachmentType,
                    attached_id: this.props.attachmentId,
                    video_author_id: this.props.authorId,
                    start_time: this.startTime,
                    pause_time: pauseTime,
                    ...this.props.metaData,
                } );
                this.startTime = pauseTime;
            } catch (e) {
                console.error( 'Analytics error', e );
            }
        }
    }

    render() {
        return (
            <AspectRatio ratio="16/9" className={ style.videoPlayer } style={ this.props.style }>
                <div id={ this.id }></div>
            </AspectRatio>
        );
    }
}
YoutubePlayer.propTypes = {
    videoId: PropTypes.string.isRequired,
};
YoutubePlayer.defaultProps = {
    onClick: () => {},
    onActivate: () => {},
};

const mapStateToProps = ( state ) => {
    return {
        screenSize: state.screenSize,
        videoPlaying: state.vars.videoPlaying,
    };
};

export default connect( mapStateToProps )( YoutubePlayer );
